module.exports = __webpack_public_path__ + "img/3-1.6e86722e.svg";